export const tapToPayCaption = 'Tap to Pay';
export const tapToPayExactCaption = 'Exact Tap to Pay';
